
import {
  CreateButton,
  Datagrid,
  FilterButton,
  List,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import { ImportCompaniesButton } from "../../components/import-companies-button.component";

const filters = [
  <TextInput label="Procurar nome" source="name" alwaysOn />,
  <TextInput label="Procurar CNPJ" source="cnpj" />,
];

const ListActions = (props: any) => {
  const { className } = props;
  return (
    <TopToolbar className={className}>
      <FilterButton style={{ paddingTop: 0 }} />
      <ImportCompaniesButton />
      <CreateButton />
    </TopToolbar>
  );
};

export const CompanyList = (props: any) => (
  <List {...props} filters={filters} actions={<ListActions />}>
    <Datagrid rowClick="edit">
      <TextField source="name" label="Nome" />
      <TextField source="cnpj" label="CNPJ" />
    </Datagrid>
  </List>
);
